import * as React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const customerLinks = [
    { text: "FREQUENTLY ASKED QUESTIONS", href: "#" },
    { text: "SHIPPING & RETURNS", href: "#" },
    { text: "YAK DOWN", href: "/yak" },
    { text: "SUSTAINABILITY", href: "#" },
    { text: "GIFT CARDS", href: "#" },
  ];

  return (
    <footer className="w-full flex flex-col font-libreFranklin">

      {/* ── Dark top section ── */}
      <div className="w-full bg-[#b6b0a8] px-8 md:px-16 lg:px-24 py-24">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Column 1 — Contact us */}
          <div className="flex flex-col gap-5">
            <h2
              className="text-black text-[16px] tracking-[0.18em] uppercase"
              style={{ fontFamily: "'Sustainability', sans-serif" }}
            >
              Contact us
            </h2>
            <ul className="flex flex-col gap-3">
              {customerLinks.map((link) => (
                <li key={link.text}>
                  <Link
                    to={link.href}
                    className="text-[#000] text-[15px] font-light tracking-wide hover:text-white transition-colors"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2 — Follow us */}
          <div className="flex flex-col gap-5">
            <h2
              className="text-black text-[16px] tracking-[0.18em] uppercase"
              style={{ fontFamily: "'Sustainability', sans-serif" }}
            >
              Follow us
            </h2>
            <a
              href="https://www.instagram.com/bodiosmongolia/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#000] text-[15px] font-light hover:text-white transition-colors"
            >
              {/* Instagram SVG icon */}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
              </svg>
              INSTAGRAM
            </a>
          </div>

          {/* Column 3 — Join the circle */}
          <div className="flex flex-col gap-5">
            <h2
              className="text-black text-[16px] tracking-[0.18em] uppercase"
              style={{ fontFamily: "'Sustainability', sans-serif" }}
            >
              Join the Bodios Yak Down circle
            </h2>

            {/* Email input */}
            <div className="flex items-center border-b border-[#000] pb-2 gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 bg-transparent text-[#000] text-[13px] font-light placeholder-[#7a746e] outline-none"
              />
              <button
                type="submit"
                aria-label="Submit"
                className="text-[#b8b0a8] hover:text-white transition-colors"
              >
                {/* Arrow right */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M13 6l6 6-6 6"/>
                </svg>
              </button>
            </div>
          </div>

        </div>
      </div>

      {/* ── White bottom section — Logo + copyright ── */}
      {/* <div className="w-full flex flex-col items-center py-10 gap-3 lg:m-10">
        <img
          src="/bodios_logo_black.png"
          alt="Bodios Yak Down"
           className="w-auto h-[5.5rem]"
        />
        <p className="text-[12px] font-light text-neutral-500 tracking-wide">
          © Bodios Yak Down 2026

        </p>
      </div> */}

    </footer>
  );
};

export default Footer;